export default "__VITE_ASSET__CmPdPF3K__"